"use client";
import { usePDF, Document, Page } from "@react-pdf/renderer";
import { useMemo, useEffect } from "react";
import { ReactElement } from "react";
import { DocumentProps } from "@react-pdf/renderer";

interface PDFManagerProps {
  document: JSX.Element | null;
  onPDFReady?: (instance: { url: string | null; loading: boolean; error: string | null }) => void;
  onUpdateReady?: (update: (newDocument: ReactElement<DocumentProps>) => void) => void;
}

export const PDFManager: React.FC<PDFManagerProps> = ({ document, onPDFReady, onUpdateReady }) => {
  // Create a fallback document if none provided
  const fallbackDocument = useMemo(() => (
    <Document>
      <Page></Page>
    </Document>
  ), []);

  const [instance, update] = usePDF({ 
    document: document || fallbackDocument
  });
  // Use useEffect to notify parent component when PDF is ready (after render)
  useEffect(() => {
    // if (instance.loading) {
    //   console.log("📄 PDF Status: Generating PDF...");
    // } else if (instance.error) {
    //   console.error("❌ PDF Status: Generation failed", instance.error);
    // } else if (instance.url) {
    //   console.log("✅ PDF Status: Generation successful, URL ready");
    // } else {
    //   console.warn("⚠️ PDF Status: No URL available yet");
    // }

    if (onPDFReady) {
      onPDFReady(instance);
    }
  }, [instance, onPDFReady]);

  // Use useEffect to notify parent component when update function is ready
  useEffect(() => {
    if (onUpdateReady) {
      onUpdateReady(update);
    }
  }, [update, onUpdateReady]);

  return null; 
};